__turbopack_context__.v({
  "btn": "menu-module__0FNfbW__btn",
  "btnLabel": "menu-module__0FNfbW__btnLabel",
  "close": "menu-module__0FNfbW__close",
  "item": "menu-module__0FNfbW__item",
  "list": "menu-module__0FNfbW__list",
  "menu": "menu-module__0FNfbW__menu",
  "open": "menu-module__0FNfbW__open",
  "panel": "menu-module__0FNfbW__panel",
});
